import { UploadValidationResult } from './upload-validation-result';

export class UploadValidationResultCollection {
  public constructor(public readonly results: UploadValidationResult[]) {}

  public valids(): UploadValidationResult[] {
    return this.results.filter(({ isValid }) => isValid);
  }

  public invalids(): UploadValidationResult[] {
    return this.results.filter(({ isValid }) => !isValid);
  }

  public haveValid(): boolean {
    return this.valids().length > 0;
  }

  public haveInvalid(): boolean {
    return this.invalids().length > 0;
  }

  public validFiles(): File[] {
    return this.valids().map(({ file }) => file);
  }

  public invalidFiles(): File[] {
    return this.invalids().map(({ file }) => file);
  }
}
